import { handleBlockbriefConfig } from './products/blockbriefDataLayer';
import { handleCommercialConfig } from './products/commercialDataLayer';
import { handleCordellConnectConfig } from './products/cordellConnectDataLayer';
import { handleCordellEstimatorConfig } from './products/cordellEstimatorDataLayer';
import { handleRppConfig } from './products/rppDataLayer';

const handleProduct = (quote, quoteConfig, category) => {
  const { type: serviceType } = quote;
  const productList = [];
  if (serviceType === 'Blockbrief')
    productList.push(...handleBlockbriefConfig(quote, quoteConfig, category));
  else if (serviceType === 'Commercial')
    productList.push(...handleCommercialConfig(quote, quoteConfig, category));
  else if (serviceType === 'CordellConnect')
    productList.push(...handleCordellConnectConfig(quote, quoteConfig, category));
  else if (serviceType === 'CordellEstimator')
    productList.push(...handleCordellEstimatorConfig(quote, quoteConfig, category));
  else if (serviceType === 'RPPRealEstate')
    productList.push(...handleRppConfig(quote, quoteConfig, category));
  return productList;
};

const handleRevenue = (productList) => {
  let totalPrice = 0;
  productList.map((product) => {
    let price = product.price * product.quantity;
      totalPrice = totalPrice + price;
  });
  return totalPrice;
};

const setDataLayer = (order) => {
  const coupon = order.quotes.coupon ? order.quotes.coupon.code : null;
  const category = order.customer.industry ? order.customer.industry : null; // customer input for Industry on Checkout
  let revenue = 0; // totalPrice less discount and tax
  let tax = 0; // 10% of Revenue with less of discount
  const products = []; // all products in data layer format

  order.quotes.quotes.map((quote) => {
    order.quoteConfiguration.products.map((quoteConfig) => {
      if (
        quote.productId === quoteConfig.product_id &&
        quoteConfig.configuration?.package !== 'trial'
      ) {
        // Handle product details and format into data layer format
        const productList = handleProduct(quote, quoteConfig, category); // List of ProductFieldObjects
        // Loop through Array of Product Objects in Data Layer Format and push to `products` array for Data Layer
        productList.forEach((product) => {
          products.push(product);
        });
      }
      if (
        quote.productId === quoteConfig.product_id &&
        quoteConfig.configuration?.package === 'trial')
        {
          window.dataLayer.push({
                  'event': 'trackEvent',
                  'eventDetails.category': 'Ecommerce',
                  'eventDetails.action': 'Free Trial',
                  'eventDetails.label': quote.productGroup + " - " + quote.headLine
              });
      }
    });
  });


  // Handle Revenue
  revenue = handleRevenue(products); // also handles discount
  // Remove discountPercentage on product object - only used for computation
  products.map((product) => {
    delete product.discountPercentage;
  });
  tax = (revenue / 1.1) * 0.1;
  const event_revenue = Number(Math.abs(revenue).toFixed(2));
  const event_tax = Number(Math.abs(tax).toFixed(2));
  const transaction_id = order.orderNumber.toString();

  const purchaseEvent = {
    "event": "purchase",
    "ecommerce": {
      "currency": "AUD",
      "items": products,
      "transaction_id": transaction_id,
      "affiliation": "Corestore AU",
      "value": event_revenue,
      "tax": event_tax,
      "coupon": coupon,
      "shipping": 0.00
    }
  };

  if (revenue > 0) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(purchaseEvent);
  }
};

export { setDataLayer };
